/**
 * Auth Layout Component
 * Layout for authentication pages (login, forgot password, etc.)
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

const AuthLayout = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}
    >
      <Outlet />
    </Box>
  );
};

export default AuthLayout;

